export default "__VITE_ASSET__Bnt6Lhs4__"